
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/works/[slug]",
      function () {
        return require("private-next-pages/works/[slug]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/works/[slug]"])
      });
    }
  